import { render, staticRenderFns } from "./AddressPrevious.vue?vue&type=template&id=cb495f72"
import script from "./AddressPrevious.vue?vue&type=script&lang=js"
export * from "./AddressPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports